import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';

const propositions = [
  ['Direct communication', 'You work directly with Alex from scope to launch.'],
  ['Clear scope before development', 'Deliverables, assumptions, and quote are agreed before paid build work expands.'],
  ['Staging before launch', 'The client reviews a working online build before production launch.'],
  ['Built for the actual project', 'The site is shaped around the business need rather than one universal package.'],
] as const;

export function WhyStudioSection() {
  return (
    <section className="section why-studio">
      <div className="shell">
        <Reveal><SectionHeading
          eyebrow="Why Malev Studio"
          title="A focused studio process with fewer handoffs."
          text="The work stays direct, written where practical, and grounded in an agreed project scope."
        /></Reveal>
        <Reveal><div className="why-studio__grid">
          {propositions.map(([title, text]) => (
            <article key={title}>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div></Reveal>
      </div>
    </section>
  );
}
